import React, { useEffect, useState } from "react";
import chatIcon from "../../../../../imgs/chatIcon.svg";
import { Checkbox, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import PSRejectModal from "./psReject";
import ErrorModal from "../../../../Merchant/Modals/errorModal";
import SuccessModal from "../../../../Merchant/Modals/successModal";
import { DeleteFilled, PlusCircleFilled } from "@ant-design/icons";

let file;
let TotalAmount = 0;
let TotalDiscount = 0;
let TotalNetAmount = 0;
let TotalTaxAmount = 0;
let TotalDelivery = 0;
let totalSubTotal = 0;
const Main = () => {
  const dispatch=useDispatch()
  const dataUser = useSelector((state) => state.dataUser);
  const buyerUserId = dataUser?.data?.user?.id;
  const QuotationFlow = useSelector((state) => state.QuotationFlow);
  const PsOrders = useSelector((state) => state.PsOrders);
  const defaultImage =
    "https://t3.ftcdn.net/jpg/03/45/05/92/360_F_345059232_CPieT8RIWOUk4JqBkkWkIETYAkmz2b75.jpg";

  const OrderData = useSelector((state) => state.OrderData);
  const [route, setRoute] = useState("");
  const [note, setNote] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [err, setErr] = useState("");
  const [data, setData] = useState("");
 


  const [partialOrder, setPartialOrder] = useState(false);
  const [quantitySending, setQuantitySending] = useState(100);
  const role = useSelector((state) => state.role);
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const router = useNavigate();
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [profileData, setProfileData] = useState({
    logo: "data:image/jpeg;base64,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",
    name: "",
    phone: "",
    email: "",
  });
  const [quotationData, setQuotationData] = useState(null);
const [alteredPrices, setAlteredPrices] = useState([]);
  const [placeOrderProfileData, setPlaceOrderProfileData] = useState({
    logo: "data:image/jpeg;base64,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",
    name: "",
    phone: "",
    email: "",
  });

  const [address, setAddress] = useState({
    address: "",
    city: "",
    regionName: "",
    regionNo: "",
    ward: "",
    lot: "",
    type: "",
    name: "",
    location: null,
  });

  const [courierName, setCourierName] = useState(null); // Required for "shipped"
  const [courierReceiptNo, setCourierReceiptNo] = useState(""); // Required for "shipped"
  const [courierReceiptImg, setCourierReceiptImg] = useState(null); // Required for "delivered"

  const [imageURL, setImageURL] = useState(null); // To display the image

  useEffect(() => {
    if (OrderData?.user) {
      setPlaceOrderProfileData({
        logo: `${OrderData?.user?.person?.image || ""} `,
        name: `${OrderData?.user?.person?.firstName || ""} ${
          OrderData?.user?.person?.lastName || ""
        }`.trim(),
        phone:
          `${OrderData?.user?.countryCode} ${OrderData?.user?.phoneNo}` || "", // Assuming 'phone' exists for vendor-owner,
        email: OrderData?.user?.email,
      });
    }
  }, []);

  const formatProgramNames = (data) => {
    return data
      .replace(/-/g, " ") // Replace hyphens with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter after space or hyphen
  };

  useEffect(() => {
    // if (user === "employee" && role === "Permanent Secretary") {
    //   return;
    // }

    TotalAmount = 0;
    TotalDiscount = 0;
    TotalNetAmount = 0;
    TotalTaxAmount = 0;
    TotalDelivery = 0;
    totalSubTotal = 0;

    const api =
      user === "vendor-owner" ? "vendor-get-details" : "buyer-get-details";
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/inv-order/${OrderData?.id}/${api}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((data) => {
        const orderdata = data?.data;
        setQuotationData(orderdata);
        setData(data?.data);
        setAlteredPrices(orderdata?.invAlteredPrices);
        if (
          OrderData?.finalStatus === "shipped" ||
          OrderData?.finalStatus === "delivered"
        ) {
          const shippedOrderData = orderdata?.invOrderStatuses?.find(
            (item) => item?.status === "shipped"
          );
          const deliveredOrderData = orderdata?.invOrderStatuses?.find(
            (item) => item?.status === "delivered"
          );
          setCourierName(shippedOrderData?.courierName);
          setCourierReceiptNo(shippedOrderData?.courierReceiptNo);
          setCourierReceiptImg(deliveredOrderData?.courierReceiptImg);
          setImageURL(deliveredOrderData?.courierReceiptImg);
        }

        if (orderdata?.vendorBranch){
            dispatch({type:"SELECTED_BRANCH_VENDOR",num:orderdata?.vendorBranch})
        }
        if (orderdata?.vendorCompany){
          dispatch({type:"SELECTED_COMPANY_VENDOR",num:orderdata?.vendorCompany})
        }

        setProfileData({
          logo:
            user === "vendor-owner"
              ? `${OrderData?.user?.person?.image || ""} `
              : orderdata?.vendorBranch?.logo ||
                orderdata?.vendorCompany?.logo ||
                "",

          name:
            user === "vendor-owner"
              ? `${OrderData?.user?.person?.firstName || ""} ${
                  OrderData?.user?.person?.lastName || ""
                }`.trim()
              : orderdata?.vendorBranch?.name ||
                orderdata?.vendorCompany?.name ||
                "",

          phone:
            user === "vendor-owner"
              ? `${OrderData?.user?.countryCode} ${OrderData?.user?.phoneNo}` ||
                "" // Assuming 'phone' exists for vendor-owner
              : orderdata?.vendorBranch?.primaryPhone || "",

          email:
            user === "vendor-owner"
              ? OrderData?.user?.email || "" // Assuming 'email' exists for vendor-owner
              : orderdata?.vendorBranch?.primaryEmail || "",
        });

        setPlaceOrderProfileData({
          logo: `${orderdata?.buyerUser?.person?.image || ""} `,
          name: `${orderdata?.buyerUser?.person?.firstName || ""} ${
            orderdata?.buyerUser?.person?.lastName || ""
          }`.trim(),
          phone:
            `${orderdata?.buyerUser?.countryCode} ${orderdata?.buyerUser?.phoneNo}` ||
            "", // Assuming 'phone' exists for vendor-owner,
          email: orderdata?.buyerUser?.email,
        });

        setAddress({
          address: orderdata?.mhsssFacility?.address || "",
          city: orderdata?.mhsssFacility?.city || "",
          regionName: orderdata?.mhsssFacility?.regionName || "",
          regionNo: orderdata?.mhsssFacility?.regionNo || "",
          ward: orderdata?.mhsssFacility?.ward || "",
          lot: orderdata?.mhsssFacility?.lot || "",
          type: orderdata?.mhsssFacility?.type || "",
          name: orderdata?.mhsssFacility?.name || "",
        });

        orderdata?.invOrderItems?.forEach((item) => {
          TotalAmount += Number(item?.totalAmount || 0);
          TotalDiscount += Number(item?.discountApplied || 0);
          TotalNetAmount += Number(item?.netAmount || 0);
          TotalTaxAmount += Number(item?.taxApplied || 0);
          TotalDelivery += Number(item?.calcDeliveryFee || 0);

          const getMatchedRate = orderdata?.invAlteredPrices?.find((rate) => {
            if (item?.invadvancepriceId) {
              return rate?.invadvancepriceId === item?.invadvancepriceId;
            }
            return rate?.invproductId === item?.invproductId;
          });
          
          // Determine the applicable price
          const unitPrice = getMatchedRate?.newPrice
            ? getMatchedRate.newPrice
            : item?.invadvanceprice
            ? item?.invadvanceprice?.price
            : Number(item?.prodBasePrice || 0);
          
          // Calculate SubTotal
          const SubTotal = Number(item?.actualUnits || 0) * unitPrice;
          
          totalSubTotal += SubTotal; // Add to the running total
        });
      })
      .catch(() => {});
  }, []);

  const formatName = (data) => {
    return data
      ?.replace(/-/g, " ") // Replace hyphens with spaces
      ?.replace(/\b\w/g, (char) => char?.toUpperCase()); // Capitalize first letter after space or hyphen
  };
  const orderDetails = [
    {
      label: "Quotaion #",
      value: `${
        data?.invOrder?.purchasedNo ? data?.invOrder?.purchasedNo : "----"
      }`,
    },
    {
      label: "Quotation Date",
      value: `${moment(
        QuotationFlow ? OrderData?.quotationDate : OrderData?.orderDate
      ).format("MM/DD/YYYY hh:mm A")}`,
    },

    {
      label: "Delivery Address",
      value: `${address?.name + " " + address?.type}`,
    },
    {
      label: "Selected Program",
      value: `${formatProgramNames(OrderData?.buyerProgram)}`,
    },

    {
      label: "Delivery Required On",
      value: `${
        data?.invOrder?.deliveryRequiredOn
          ? moment(data?.invOrder?.deliveryRequiredOn).format("MM/DD/YYYY")
          : "----"
      }`,
    },
  ];

  const ProductCard = ({ item }) => {
    const data = {
      name: item?.invproduct?.name,
      image:
        item?.invproduct?.invproductgallaries?.find(
          (gallery) => gallery?.isCoverImg
        )?.image || defaultImage,
      quantity: item?.actualUnits,
      totalAmount: item?.totalAmount,
      invadvanceprice: item?.invadvanceprice,
      basePrice: item?.prodBasePrice,
      unit: item?.invproduct?.pricingUnit,
      discount: item?.discountApplied,
      tax: item?.taxApplied,
      delivery: item?.calcDeliveryFee,
    };
    return (
      <div className="w-full bg-[#F6F6F6] rounded-sm p-4 flex flex-col gap-4">
        <div className="flex  gap-4">
          <img
            src={data?.image} // Replace with your product image
            alt="Sony wireless headphones"
            className="w-24 h-24 rounded object-cover"
          />
          <div>
            <h2 className="text-[0.95rem] font-semibold">{data?.name}</h2>
            <p className="text-sm text-gray-500">
              $
              {data?.invadvanceprice !== null
                ? data?.invadvanceprice?.price
                : data?.basePrice}
              /{data?.unit}
            </p>
            <div className="flex justify-between items-center gap-12">
              <p className="text-sm font-medium text-gray-600">
                Order quantity
              </p>
              <p className="text-lg font-semibold">{data?.quantity}</p>
            </div>
            <div className="flex justify-between items-center gap-12">
              <p className="text-sm font-medium text-gray-600">Discount</p>
              <p className="text-sm font-semibold">${data?.discount}</p>
            </div>
            <div className="flex justify-between items-center gap-12">
              <p className="text-sm font-medium text-gray-600">Tax</p>
              <p className="text-sm font-semibold">${data?.tax}</p>
            </div>
            <div className="flex justify-between items-center gap-12">
              <p className="text-sm font-medium text-gray-600">Delivery</p>
              <p className="text-sm font-semibold">${data?.delivery}</p>
            </div>
            {/* <div className="flex items-center gap-2 mt-2">
            <input
              type="checkbox"
              checked={partialOrder}
              onChange={(e) => setPartialOrder(e.target.checked)}
              className="h-5 w-5 text-red-800 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label className="text-sm font-medium text-gray-600">
              Send Partial order
            </label>
          </div> */}
            <div className={`${user === "vendor-owner" ? "" : "hidden"}`}>
              <Checkbox
                label="Send Partial Order"
                className="checkk4 mt-2"
                onChange={(e) => setPartialOrder(e.target.checked)}
                checked={partialOrder}
              >
                <label className="text-sm font-medium text-gray-600">
                  Send Partial order
                </label>
              </Checkbox>
            </div>

            {partialOrder && (
              <div className="flex items-center gap-4 mt-4 bg-white w-full p-2">
                <p className="text-sm font-medium text-gray-600 flex-shrink-0 w-2/3 px-2">
                  Quantity Sending
                </p>
                <input
                  type="number"
                  value={quantitySending}
                  onChange={(e) => setQuantitySending(Number(e.target.value))}
                  className="w-1/3 bg-[#F0F0F0] rounded p-2 text-center"
                />
              </div>
            )}
          </div>
        </div>

        <div className="border-t border-gray-200 pt-2">
          <p className="text-right text-lg font-semibold text-gray-800">
            ${data?.totalAmount}
          </p>
        </div>
      </div>
    );
  };

  const changeStatus = () => {
    const api = `v1/inv-order/${OrderData?.id}/buyer-convert-quote-to-order`;

    axios
      .patch(`${process.env.REACT_APP_BASE_URL}/${api}`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setErr("Order has been created successfully");
        setRoute("/Inventory-Vendor-Orders");
        setShowSuccessModal(true);
        // router("/Inventory/Quotations");
      })
      .catch((err) => {
        setErr(err?.response?.data?.message);
        setErrorModal(true);
      });
  };

  const CancelQuotation = () => {
    const api = `v1/inv-order/${OrderData?.id}/buyer-cancel-quotation`;

    axios
      .patch(`${process.env.REACT_APP_BASE_URL}/${api}`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setErr("Quotation Request Cancelled Successfully");
        setRoute(-1);
        setShowSuccessModal(true);
        // router("/Inventory/Quotations");
      })
      .catch((err) => {
        setErr(err?.response?.data?.message);
        setErrorModal(true);
      });
  };

  return (
    <div>
      <div className="mt-3  rounded-md  p-[3rem] pt-[2rem] mb-6  sm:min-h-[360px] bg-[#F6F4F4] shadow-lg">
        <div className="">
          {/* First Div */}
          <div className="flex gap-4 mb-[1rem]">
            <div className="flex-1">
              <div className="bg-white p-4 h-full rounded-sm">
                <div className=" flex  justify-between w-full p-2 h-full rounded-md flex-col">
                  <div className="flex justify-between">
                    <span className="text-sm font-semibold">Status</span>

                    <div
                      className={`${
                        data?.invOrder?.finalStatus === "awaited-ps"
                          ? "bg-gray-100 text-gray-800" // Awaited PS
                          : data?.invOrder?.finalStatus === "ps-rejected" ||
                            data?.invOrder?.finalStatus ===
                              "vendor-rejected-quot"
                          ? "bg-red-100 text-red-800" // PS Rejected
                          : data?.invOrder?.finalStatus === "ps-approved" ||
                            data?.invOrder?.finalStatus ===
                              "vendor-accepted-quot"
                          ? "bg-green-100 text-green-800" // PS Approved
                          : data?.invOrder?.finalStatus === "submitted" ||
                            data?.invOrder?.finalStatus === "re-submitted"
                          ? "bg-blue-200 text-blue-700" // Submitted or Re-Submitted
                          : data?.invOrder?.finalStatus === "in-progress"
                          ? "bg-yellow-100 text-[#e0aa36]" // In Progress
                          : data?.invOrder?.finalStatus === "partial"
                          ? "bg-orange-100 text-orange-800" // Partial
                          : data?.invOrder?.invOrder?.finalStatus === "shipped"
                          ? "bg-purple-100 text-purple-800" // Shipped
                          : data?.invOrder?.finalStatus === "delivered"
                          ? "bg-teal-100 text-teal-800" // Delivered
                          : data?.invOrder?.finalStatus === "delivered-issue"
                          ? "bg-pink-100 text-pink-800" // Delivered with Issue
                          : data?.invOrder?.finalStatus === "recieved"
                          ? "bg-indigo-100 text-indigo-800" // Received
                          : data?.invOrder?.finalStatus === "cancelled"
                          ? "bg-red-200 text-red-800" // Cancelled
                          : "bg-gray-100 text-gray-800" // Default Style
                      } rounded-full pl-4 pr-4 p-1 text-center font-semibold capitalize text-[0.95rem]`}
                    >
                      {data?.invOrder?.finalStatus === "awaited-ps"
                        ? "Awaited PS"
                        : data?.invOrder?.finalStatus === "ps-rejected"
                        ? "PS Rejected"
                        : data?.invOrder?.finalStatus === "ps-approved"
                        ? "PS Approved"
                        : data?.invOrder?.finalStatus === "submitted"
                        ? "Submitted"
                        : data?.invOrder?.finalStatus === "re-submitted"
                        ? "Re-Submitted"
                        : data?.invOrder?.finalStatus === "in-progress"
                        ? "In Progress"
                        : data?.invOrder?.finalStatus === "partial"
                        ? "Partial"
                        : data?.invOrder?.finalStatus === "shipped"
                        ? "Shipped"
                        : data?.invOrder?.finalStatus === "delivered"
                        ? "Delivered"
                        : data?.invOrder?.finalStatus === "delivered-issue"
                        ? "Delivered Issue"
                        : data?.invOrder?.finalStatus === "recieved"
                        ? "Received"
                        : data?.invOrder?.finalStatus === "cancelled"
                        ? "Cancelled"
                        : data?.invOrder?.finalStatus === "vendor-accepted-quot"
                        ? "Quotation Accepted "
                        : data?.invOrder?.finalStatus === "vendor-rejected-quot"
                        ? "Quotation Rejected"
                        : data?.invOrder?.finalStatus}
                    </div>
                  </div>
                  {orderDetails?.slice(0, 2)?.map((item) => (
                    <div className="flex justify-between mt-2">
                      <span className="text-sm text-gray-700 font-medium">
                        {item.label}
                      </span>
                      <span className="text-sm font-semibold">
                        {item.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex-1">
              <div className="bg-white p-4 h-full px-5 rounded-sm">
                <div className=" flex  justify-between w-full p-2 h-full rounded-md px-6 flex-col">
                  {orderDetails?.slice(2, 5)?.map((item) => (
                    <div className="flex justify-between mt-2">
                      <span className="text-sm text-gray-700 font-medium">
                        {item.label}
                      </span>
                      <span className="text-sm font-semibold">
                        {item.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className={`${"flex gap-4 mb-[1rem]"} `}>
            <div className="flex-1">
              <h3 className="text-[0.93rem] font-semibold mb-2">Created By:</h3>
              <div className="bg-white p-3 rounded-sm w-[40%]">
                <div className="flex items-center space-x-4 ">
                  <img
                    src={placeOrderProfileData?.logo}
                    alt="Buyer Name"
                    className="w-14 h-14 rounded-full"
                  />
                  <div>
                    <h2 className="text-[0.95rem] font-semibold capitalize">
                      {placeOrderProfileData?.name}
                    </h2>
                    {/* <p className="text-sm text-gray-600">
                      {placeOrderProfileData?.phone}
                    </p>
                    <p className="text-sm text-gray-600">
                      {placeOrderProfileData?.email}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second Div */}
          <div className={`${"flex gap-4 mb-[1rem]"} `}>
            <div className="flex-1">
              <h3 className="text-[0.93rem] font-semibold mb-2">
                Vendor detail:
              </h3>
              <div className="bg-white p-3 rounded-sm w-[40%]">
                <div className="flex items-center space-x-4 ">
                  <img
                    src={profileData?.logo}
                    alt="Buyer Name"
                    className="w-14 h-14 rounded-full"
                  />
                  <div>
                    <h2 className="text-[0.95rem] font-semibold capitalize">
                      {profileData?.name}
                    </h2>
                    {/* <p className="text-sm text-gray-600">
                      {profileData?.phone}
                    </p>
                    <p className="text-sm text-gray-600">
                      {profileData?.email}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex gap-3 flex-col">
            <div className="bg-white p-4 w-full">
              <h2 className="text-gray-700 font-bold text-[0.95rem]">
                Products Detail
              </h2>
              {/* {localCart.length > 0 && ( */}
              <div className="mx-auto w-full grid grid-cols-2 gap-2  mt-1">
              {quotationData?.invOrderItems?.map((item) => {
                    const getMatchedRate = alteredPrices?.find((rate) => {
                      if (item?.invadvancepriceId) {
                        return rate?.invadvancepriceId === item?.invadvancepriceId;
                      }
                      return rate?.invproductId === item?.invproductId;
                    });
                    
                    console.log("Matched Rate:", getMatchedRate);

                    return (
                      <div
                        className="w-full bg-[#F6F6F6] rounded-sm p-4 flex flex-col gap-4"
                        key={item.id}
                      >
                        <div className="flex gap-4">
                          <img
                            src={
                              item?.invproduct?.invproductgallaries?.find(
                                (gallery) => gallery?.isCoverImg
                              )?.image || defaultImage
                            }
                            alt={item?.invproduct?.name}
                            className="w-24 h-24 rounded object-cover"
                          />
                          <div>
                            <h2 className="text-[0.95rem] font-semibold">
                              {item?.invproduct?.name}
                            </h2>

                            <div className="flex justify-between items-center gap-12">
                              <p className="text-sm font-medium text-gray-600">
                                Order quantity
                              </p>
                              <p className="text-lg font-semibold">
                                {item?.actualUnits}
                              </p>
                            </div>

                            <div className="flex justify-between items-center gap-12 mt-1">
                              <p className="text-sm font-medium text-gray-600">
                                Current Rate
                              </p>
                              <p className="text-sm font-semibold">
                                $
                                {item?.invadvanceprice !== null
                                  ? item?.invadvanceprice?.price
                                  : item?.prodBasePrice}
                                /{item?.invproduct?.pricingUnit}
                              </p>
                            </div>
                            <div className={`${getMatchedRate?.newPrice !== null && getMatchedRate?.newPrice !== undefined ? "flex justify-between items-center gap-12 mt-1" :"hidden"}`}>
                              <p className="text-sm font-medium text-gray-600">
                                Revised Rate
                              </p>
                             
                                  <p className="text-sm font-semibold">
                                    ${getMatchedRate?.newPrice}
                                  </p>
                               
                              
                            </div>

                            
                          </div>
                        </div>

                        <div className="border-t border-gray-200 pt-2">
                          <p className="text-right text-lg font-semibold text-gray-800">
                            ${item?.totalAmount}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-6 mt-4">
        <button
          className={`${ OrderData?.finalStatus === "cancelled" ? "hidden":"px-6 py-2 bg-red-600 text-white rounded-md w-[14rem]"}`}
          onClick={() => {
            CancelQuotation()
          }}
        >
          Cancel
        </button>
        <button
          className={`${
            OrderData?.finalStatus === "vendor-accepted-quot" &&
            buyerUserId === data?.buyerUser?.id
              ? // PsOrders?.value === "Quotations"
                "px-6 py-2 bg-primary text-white rounded-md w-[14rem]"
              : "hidden"
          }`}
          onClick={() => {
            dispatch({
              type: "PLACE_ORDER_DATA",
              num: {
                deliveryRequiredOn: data?.invOrder?.deliveryRequiredOn
                ? moment(data?.invOrder?.deliveryRequiredOn).format("MM/DD/YYYY")
                : null,
                mhsssLabel:address?.name + " " + address?.type,
                // mhsssfacilityId: "7e3be128-9454-44e6-830b-fdefe4a65288",
                program: formatProgramNames(OrderData?.buyerProgram),
                type: address?.type,
                TotalItems : quotationData?.invOrderItems?.length ?? 0,
                TotalAmount:TotalAmount,
                TotalDiscount:TotalDiscount,
                TotalNetAmount:TotalNetAmount,
                TotalTaxAmount:TotalTaxAmount,
                TotalDelivery:TotalDelivery,
                totalSubTotal:totalSubTotal

              },
            });
          
            router("/PurchaseOrder");
            // changeStatus();
          }}
          
        >
          Create Purchase Order
        </button>
      </div>

      {showRejectModal && (
        <PSRejectModal
          setShow={setShowRejectModal}
          onSubmit={() => {
            changeStatus("ps-rejected");
          }}
          note={note}
          setNote={setNote}
        />
      )}

      {errorModal && <ErrorModal setShow={setErrorModal} err={err} />}
      {showSuccessModal && (
        <SuccessModal setShow={setShowSuccessModal} err={err} route={route} />
      )}
    </div>
  );
};

export default Main;
